import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/security/adminuser/configuration/generateToken/filter'; // Importing Filters component
import Table from 'views/security/adminuser/configuration/generateToken/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the generateTokenAgentListView.
 * @extends JetView
 */
export default class generateTokenAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };
        const left = {
            // Left side layout configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for the title
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Generar Token'), // Label for generating token
                            width: 150,
                        },
                    ],
                },
                Filters, // Adding Filters component
                Table, // Adding Table component
                toolbar, // Adding toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        if (
            !devConfig.getPermAction(
                // Check permissions for the action
                'AdminuserConfigurationGenerateTokenMenu',
                'Menu',
            )
        ) {
            this.show('./security.adminuser.configuration.securityChanges'); // Redirect if no permission
        } else {
            return {
                // Return the layout configuration
                type: 'wide',
                cols: [left],
            };
        }
    }
}

// FILE DOCUMENTED
